
<h4 class="page-title" [hidden]="modal">
  <button class="btn btn-outline-blue btn-rounded" (click)="voltar()"   style="margin-right: 5px;">
    <i class="fa fa-arrow-left ct-point" ></i>
  </button>
  <i class="fe-market "></i> Detalhes do pedido </h4>



<div class="row" *ngIf="_pedido && _pedido.empresa">
  <div class="col-12 col-xl-5 col-sm-6" [ngClass]="{'col-xl-6': modal}" >
    <div class="card-box ribbon-box"  >
      <h4 class="header-title mb-3 float-left">Pedido <b class="codigo-pedido">#{{_pedido?.codigo}}</b>
        <span class="badge badge-primary ml-2 mr-2" *ngIf="_pedido.multipedido">multipedido </span>
        <ng-container *ngIf="_pedido.aceito">
          <button   type="button" kendoButton   class="k-button k-primary ml-2 mr-1"  *ngIf="_pedido.podeEditar"
                    (click)="editarPedido(_pedido)" title="editar pedido" kendoTooltip>
            <i class="fa fa-edit"></i>
          </button>

          <ng-container *ngIf="(!configImpressao || !configImpressao?.multiplasImpressoras) &&  !_pedido.aguardandoPagamentoOnline">

            <button  *ngIf="!configImpressao ||  (configImpressao.layoutPedido !== 'Ambos')" title="imprimir" kendoTooltip
                     type="button" kendoButton   class="k-button   "  (click)="imprimaPedidoDoLayout( )" [hidden]="!empresa.id">
              <i class="fa fa-print"></i></button>

            <ng-container *ngIf="configImpressao?.layoutPedido === 'Ambos'">
              <button type="button"  kendoButton  class="k-button   "   (click)="imprimaPedido('PedidoCompleto')" title="imprimir" kendoTooltip>
                <i class="fa fa-print"></i>&nbsp;Completo</button>
              <button type="button" kendoButton   class="k-button  ml-1"   (click)="imprimaPedido('PedidoResumido')" title="imprimir" kendoTooltip>
                <i class="fa fa-print"></i>&nbsp;Resumido</button>

            </ng-container>
          </ng-container>

          <kendo-dropdownbutton   [data]="configImpressao.impressoras" [popupSettings]="{animate: true}"
                                  (itemClick)="imprimaNaImpressora($event)" [textField]="'setor'"
                                  *ngIf="configImpressao?.multiplasImpressoras  &&  !_pedido.aguardandoPagamentoOnline"  >

          <i class="k-icon k-i-printer"></i>  Imprimir
          </kendo-dropdownbutton >

          <app-copiar-pedido [pedido]="_pedido" [exibirTexto]="true" ></app-copiar-pedido>
        </ng-container>

        <app-pedido-origem class="em-linha" [pedido]="_pedido"></app-pedido-origem>
        <div *ngIf="_pedido.doOpenDelivery">
          <button type="button" class="btn btn-link text-primary font11 p-0"
                  [disabled]="carregandoOrigemOpenDelivery" (click)="abraJsonOrigemOpenDelivery()">
            <i class="k-icon k-i-loading mr-1" *ngIf="carregandoOrigemOpenDelivery"></i>
            Ver dados da API
          </button>
          <p class="text-danger font11 mb-0" *ngIf="erroOrigemOpenDelivery">{{erroOrigemOpenDelivery}}</p>
        </div>

        <p class=" text-muted font11 mb-0" *ngIf="_pedido.referenciaExterna && (!_pedido.origemExterna )"
           [hidden]="_pedido.delivery?.origem === 'ifood'" >
          <br>
          Ref. Externa:

          <a target="_blank"  href="{{host}}/integracaoerp/pedido/{{_pedido.guid}}"  >
            {{_pedido.referenciaExterna}}
          </a>

        </p>

        <p *ngIf="_pedido.requests && usuario.admin" class="mt-0" >
          <a  class="text-primary font11" href="#"  (click)="abraModalRequestsParceiro()">  ver requests</a>
        </p>

      </h4>

      <div class="float-right  " *ngIf="empresa.integracaoOpendelivery?.ativa"  >
         <button type="button" class="btn btn-warning btn-sm  " (click)="abraModalEventosOpenDelivery()">
           eventos <b>Open Delivery</b></button>
      </div>
      <div class="float-right ml-1 mb-2" *ngIf="_pedido.doOpenDelivery">
        <button type="button" class="btn btn-warning btn-sm" (click)="abraModalEventosOpenDelivery(true)">
          Ver notificações <b>OpenDelivery</b>
        </button>
      </div>

      <button   type="button"   class="btn btn-danger btn-sm mb-3 float-right"
                [disabled]="processando" *ngIf="_pedido.enviarParaPDV"
                (click)="notifiqueSistemaIntegrado()" title="enviar pedido para  {{integracao.sistema}}" kendoTooltip >

        <i class="k-i-loading k-icon mr-1" *ngIf="processando"></i>
        Enviar Pedido {{integracao.sistema}}</button>

      <div class="ribbon-content">
        <div  class="fundo" >
          <div class="d-flex justify-content-center align-items-center" style="height: 400px" *ngIf="!_pedido && carregou">
            <div class="align-self-center text-center" style="color: #F1556C;">
              <i class="fas fa-exclamation-triangle" style="font-size: 48px"></i>
              <p>
                Não encontrado!
              </p>
            </div>
          </div>

          <div *ngIf="_pedido.naoNotificado" class="alert alert-danger alert-dismissible fade show mt-1" role="alert">
            <p>{{_pedido.erroExterno}}</p>

            <a *ngIf="_pedido.requests && usuario.admin" href="#" (click)="abraModalRequestsParceiro()">
              ver requests
            </a>


            <button type="button" class="close" data-dismiss="alert" aria-label="Fechar">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>


          <div *ngIf="_pedido.id">
            <div class="alert alert-info mt-1" *ngIf="_pedido.producaoInterna">
              <strong>Pedido interno de produção</strong>
              <span class="d-block">Sem cobrança. Os ingredientes são baixados ao concluir a produção e marcar Pronto.</span>
            </div>
            <div class="alert alert-info mt-1" *ngIf="_pedido.reposicaoInterna">
              <strong><i class="fas fa-truck-loading mr-1"></i>Reposição interna</strong><br>
              Filial: {{_pedido.reposicaoInterna.filial.nome}}
              <span *ngIf="_pedido.reposicaoInterna.filial.cnpj">
                — CNPJ {{_pedido.reposicaoInterna.filial.cnpj}}
              </span>
              <span class="d-block mt-1" *ngIf="_pedido.status === 'Entregue'">
                O estoque da fábrica já foi baixado. A filial ainda precisa confirmar o recebimento para registrar a entrada.
              </span>
            </div>
            <div class="media mb-2 linha-media" *ngIf="_pedido.externo"  >
              <div class="media-body">
                <div class="mb-2">
                  <i class="badge {{badgeParceiroExterno}} text-left mr-1">{{_pedido.externo.sistema}}</i>

                  <span  class="mr-1">
                   <a target="_blank"  href="{{host}}/{{pathExterno()}}/{{_pedido.idLojaExterna}}/order/{{_pedido.referenciaExterna}}"  >
                     <b> #{{_pedido.externo.displayId}}</b>
                  </a>
                  </span>
                  <span class="  text-blue mb-1 " *ngIf="_pedido.externo?.codigoRetirada"   style="float: right">
                    Codigo coleta: <b>{{_pedido.externo?.codigoRetirada}}</b>
                  </span>

                </div>

                <a *ngIf="_pedido.externo?.localizadorPedido" class="mb-0"
                   href="{{_pedido.externo.urlConfirmaEntrega}}" target="_blank">
                  Localizador do pedido: <b>{{_pedido.externo.localizadorPedido}}</b>
                </a>

                <p *ngIf="_pedido.externo?.entregadorPor"  class="mb-0">
                    <b>{{_pedido.externo.entregadorPor}}</b>
                </p>

                <p class="mb-0" *ngIf="_pedido.externo.numeroCliente">
                  Contato por Telefone {{_pedido.externo.sistema}}:

                  <i class="fa fa-phone mr-1"></i>
                  <b> {{_pedido.externo.numeroCliente}}</b>
                </p>

                <p class="mb-0" *ngIf="_pedido.externo.cpfNota">
                  Incluir cpf na nota:
                  <b> {{_pedido.externo.cpfNota}}</b>
                </p>
              </div>
            </div>

            <div class="desktop">
              <div class="produto   pb-0"    *ngIf="_pedido.mesa">
                <div class="media mt-2">
                  <div class="media-body">
                    <h5 class="mt-0 mb-1"> <i class="fa fa-table fa-lg"></i><span class="ml-1">{{_pedido.empresa.identificadorMesa}}</span></h5>
                  </div>
                  <h5 class="mt-0 text-right">
                    <strong>  {{_pedido.mesa.nome}}</strong>
                  </h5>
                </div>

              </div>
              <div class="produto   pb-0"   *ngIf="_pedido.balcao && _pedido.cliente" >
                <div class="media mt-2">
                  <div class="media-body">
                    <h5 class="mt-0 mb-1"> <i class="fe-user fa-lg"></i><span>Cliente</span></h5>
                  </div>
                  <h5 class="mt-0 text-right">
                    <strong>{{_pedido.cliente.nome}}</strong>
                  </h5>
                </div>

              </div>

              <div class="produto   pb-0"   *ngIf="!_pedido.balcao" >
                <div class="media mt-2">
                  <div class="media-body">
                    <h5 class="mt-0 mb-1"> <i class="fe-user fa-lg"></i><span>Cliente</span></h5>
                  </div>
                  <h5 class="mt-0 text-right">
                    <a [routerLink]="'/admin/contatos/' + _pedido.cliente.codigoPais + _pedido.cliente.telefone">
                      <strong>{{_pedido.cliente.nome}}</strong> <br>
                      <label class="text-muted mt-1">{{_pedido.cliente.telefone | tel: _pedido.cliente.codigoPais}}</label>
                    </a>

                  </h5>
                </div>

              </div>

              <div class="produto pb-0" *ngIf="obtenhaNomeLojaVenda(_pedido, modoGrupoLojas) as nomeLojaVenda">
                <div class="media mt-2">
                  <div class="media-body">
                    <h5 class="mt-0 mb-1">
                      <i class="fe-home fa-lg"></i><span>Loja da venda/pagamento</span>
                    </h5>
                  </div>
                  <h5 class="mt-0 text-right"><strong>{{nomeLojaVenda}}</strong></h5>
                </div>
              </div>

              <div class="produto pt-2 pb-1" *ngIf="_pedido.formaDeEntrega">
                <div class="media mt-1">
                  <div class="media-body">
                    <h5 class="mt-0 mb-1"><span> <i class="fe-map-pin fa-lg"></i> Forma de Entrega</span></h5>
                  </div>
                  <h5 class="mt-0"><strong>{{descrevaFormaDeEntrega(_pedido)}}</strong></h5>

                </div>
                <div class="media mt-1" *ngIf="_pedido.horarioEntregaAgendada">
                  <div class="media-body">
                    <h5 class="mt-0 mb-1"><span> <i class="fe-clock fa-lg"></i> Agendado para</span></h5>
                  </div>
                  <h5 class="mt-0"><strong>{{_pedido.horarioEntregaAgendada | date: "dd/MM/yyyy 'às' HH:mm"}}</strong></h5>
                </div>

                <div class="pt-0 pb-0 ml-2" *ngIf="_pedido.formaDeEntrega === FormaDeEntrega.RECEBER_EM_CASA">
                  <h5 class="text-muted"><i class="fas fa-map-marker-alt"></i> Endereço Escolhido</h5>
                  <h5>
                    {{_pedido.enderecoCompleto}}
                  </h5>




                  <app-acoes-delivery [pedido]="_pedido" [empresa]="modoGrupoLojas ? _pedido.empresa : empresa"
                                        [modoGrupoLojas]="modoGrupoLojas" [exibirDetalhes]="true"
                                        *ngIf="!_pedido.retirar"  ></app-acoes-delivery>


                </div>
              </div>
              <h5 class="mt-2 mb-1"><span>
             <i class="fe-shopping-bag fa-lg"></i>
            Produtos</span></h5>

  <app-producao-pedido #producaoPedido [pedidoId]="modoGrupoLojas ? null : _pedido.id"
                      [moduloComissionamentoAtivo]="moduloComissionamentoAtivo" [labelComissionado]="labelOperacionalComissionado()"
                      [producaoAtiva]="producaoPedidosHabilitada"
                                   (atualizado)="carregueHistoricoPedido()"></app-producao-pedido>

              <div *ngFor="let empresa of _pedido.empresas">

                <h5 class="font-weight-bold mb-0 mt-2 text-uppercase" *ngIf="_pedido.origem === 'multiloja'">
                  <i class="fe-home fa-lg "></i>   {{empresa.nome}}
                      <span class="font-12 text-muted ml-2">{{empresa.totalProdutos}} {{empresa.totalProdutos > 1 ? 'produtos': 'produto'}}</span>
                </h5>

                <div *ngFor="let item of obtenhaItens(empresa)" class="produto pt-2 pb-2 ml-1 item_produto dashed">
                  <div class="media">
                    <div class="media-body">
                      <h5 class="mt-0 mb-1">
                        {{item.qtde}}{{item.unidadeTxt}}   {{item.descricao}}
                      </h5>
                      {{item.produto.descricao}}

                      <small class="d-block text-info" *ngIf="item.unidadeCompra">
                        Unidade de compra: {{item.unidadeCompra.quantidade | number:'1.0-6'}} ×
                        {{item.unidadeCompra.descricao}} (fator {{item.unidadeCompra.fatorConversao | number:'1.0-6'}};
                        entrada prevista {{item.unidadeCompra.quantidadeBaseDestino | number:'1.0-6'}})
                      </small>

                      <div *ngIf="item.adicionaisImprirmir?.length" >
                       <span  *ngFor="let last = last;let adicional of item.adicionaisImprirmir " class="d-block ml-2 font-weight-bold">
                         {{adicional.descricao}}{{last ? '' : ', '}}
                       </span>
                      </div>
                      <span *ngIf="item.observacao"  class="mt-1 d-block"> Obs.:<i>"{{item.observacao}}"</i></span>
                      <div class="mt-2 comissionado-box producao-item-box" *ngIf="producaoPedido.producaoDoItem(item.id) as producao">
                        <span class="comissionado-label">Produção</span>
                        <span class="comissionado-atual">
                          <i class="fas fa-utensils mr-1"></i>
                          {{producao.atendimento === 'vitrine' ? 'Bolo pronto' : producao.atendimento === 'produzir' ? 'Produzir' : 'Não selecionado'}}
                          <span *ngIf="moduloComissionamentoAtivo && producao.atendimento === 'produzir'"> · {{labelOperacionalComissionado()}}: {{producao.comissionado?.nome || 'Não selecionado'}}</span>
                        </span>
                        <button type="button" class="btn btn-sm comissionado-alterar ml-auto"
                                *ngIf="producaoPedido.producaoAtiva && !producao.consumo && (producao.pedido.status === 0 || producao.pedido.status === 1)"
                                [disabled]="producaoPedido.salvando" (click)="producaoPedido.edite(producao)">
                          <i class="fas fa-pencil-alt mr-1"></i>Alterar
                        </button>
                        <div class="producao-desativada" *ngIf="!producaoPedido.producaoAtiva">
                          <span>Produção de pedidos desativada. Solicite a ativação ao administrador, nas configurações do módulo Estoque.</span>

                        </div>
                      </div>
                      <div class="mt-2 comissionado-box" *ngIf="produtoExigeComissionado(item)">
                        <span class="comissionado-label">{{labelOperacionalComissionado() | titlecase}}</span>
                        <span class="comissionado-atual">
                          <i class="fas fa-user-tie mr-1"></i>
                          {{nomeComissionadoItem(item) || 'Não selecionado'}}
                        </span>
                        <button type="button" class="btn btn-sm comissionado-alterar ml-auto"
                                (click)="abraModalComissionamento()">
                          <i class="fas fa-pencil-alt mr-1"></i>
                          Alterar
                        </button>
                      </div>
                      <div class="mt-2 comissao-nao-configurada-box" *ngIf="produtoSemComissaoConfigurada(item)">
                        <span class="comissao-nao-configurada-aviso">
                          <i class="fas fa-exclamation-triangle mr-2"></i>
                          Este produto não possui comissão configurada.
                        </span>
                        <button type="button" class="btn btn-sm comissao-configurar ml-auto"
                                (click)="abraModalConfiguracaoComissao(item)">
                          <i class="fas fa-cog mr-1"></i>
                          Configurar
                        </button>
                      </div>
                    </div>

                    <h5 class="preco mt-0" *ngIf="!item.valorResgatado && !_pedido.producaoInterna">
                      {{item.total | currency: 'BRL'}}
                    </h5>
                    <h5 class="mt-0" *ngIf="item.valorResgatado">
                      -{{item.valorResgatado}} {{_pedido.acumulo}}
                    </h5>
                  </div>
                </div>

              </div>


            </div>

            <div class="produto pt-2 pb-1" *ngIf="_pedido.observacoes">
              <div class="media mt-1">
                <div class="media-body">
                  <h5 class="mt-0 mb-1"><span>Observação</span></h5>
                </div>
                <h5 class="mt-0">
                  <i>
                    {{_pedido.observacoes}}
                  </i>
                </h5>
              </div>
            </div>

            <div class="linha mt-0 mb-0" *ngIf="_pedido.itens.length > 3"></div>

            <div class="  totais  pt-2 pb-0">
              <div class="media">
                <div class="media-body">
                  <h5 class="mt-0 mb-1 text-muted"><span>Subtotal</span></h5>
                </div>
                <h5 class="mt-0 text-muted font-16"> {{_pedido.subvalor | currency: 'BRL'}}</h5>
              </div>

              <div class="media" *ngIf=" _pedido.desconto">
                <div class="media-body">
                  <h5 class="mt-0 mb-1">
                    <span>Desconto</span>
                    <span style="font-size: 10px"   *ngIf="_pedido.cupom && !_pedido.descontoTaxaEntrega"><i>({{ _pedido.cupom  }})</i></span>
                    <span *ngIf="_pedido.patrocinadoresDesconto">(<i>{{_pedido.patrocinadoresDesconto}}</i>)</span>
                    <span style="font-size: 10px" *ngIf="_pedido.promocoesDesconto"><i>(Promoção: {{_pedido.promocoesDesconto}})</i></span>

                    <br>
                    </h5>
                </div>
                <h5 class="mt-0">-{{_pedido.desconto | currency: 'BRL'}}</h5>
              </div>

              <div class="media" *ngIf=" _pedido.descontoFormaDePagamento">
                <div class="media-body">
                  <h5 class="mt-0 mb-1"><span>{{_pedido.descricaoDescontoFormaDePagamento}}</span><br>
                  </h5>
                </div>
                <h5 class="mt-0">-{{_pedido.descontoFormaDePagamento | currency: 'BRL'}}</h5>
              </div>

              <div class="media" *ngIf="_pedido.descontoFormaDeEntrega">
                <div class="media-body">
                  <h5 class="mt-0 mb-1"><span>{{_pedido.descricaoDescontoFormaDeEntrega || 'Desconto Forma de Entrega'}}</span></h5>
                </div>
                <h5 class="mt-0">-{{_pedido.descontoFormaDeEntrega | currency: 'BRL'}}</h5>
              </div>

              <div class="media" *ngIf=" _pedido.taxaEntrega || _pedido.descontoTaxaEntrega">
                <div class="media-body">
                  <h5 class="mt-0 mb-1"><span>Taxa de entrega</span>
                    <ng-container *ngIf="_pedido.descontoTaxaEntrega">
                      <span class="lh20"> <br>Desconto {{_pedido.cupom ? "(" + _pedido.cupom + ")" : ""}}</span>
                      <span class="lh20"> <br>Total taxa de entrega</span>
                    </ng-container>
                  </h5>

                </div>

                <h5 class="mt-0">
                  <ng-container *ngIf="_pedido.descontoTaxaEntrega">
                    <span class="riscado lh20">
                      +{{_pedido.taxaEntrega + _pedido.descontoTaxaEntrega | currency: 'BRL'}}
                      <br>
                    </span>
                    <span class="lh20">
                      -{{_pedido.descontoTaxaEntrega | currency: 'BRL'}}
                      <br>
                    </span>
                  </ng-container>

                  +{{_pedido.taxaEntrega | currency: 'BRL'}}</h5>

              </div>

              <div class="media" *ngIf=" _pedido.externo?.taxaServico">
                <div class="media-body">
                  <h5 class="mt-0 mb-1"><span>Taxa de serviço {{_pedido.externo.sistema}}</span>
                  </h5>

                </div>

                <h5 class="mt-0">  +{{_pedido.externo?.taxaServico | currency: 'BRL'}}</h5>
              </div>

              <div class="media" *ngIf="_pedido.pagamento && _pedido.pagamento.formaDePagamento === 'Dinheiro'">
                <div class="media-body">
                  <h5 class="mt-0 mb-1"><span>Troco</span></h5>
                </div>
                <h5 class="mt-0 preco">{{_pedido.troco | currency: 'BRL'}}</h5>
              </div>

              <div class="media" *ngIf=" _pedido.taxaFormaDePagamento">
                <div class="media-body">
                  <h5 class="mt-0 mb-1"><span>Taxa forma de pagamento</span></h5>
                </div>
                <h5 class="mt-0">+{{_pedido.taxaFormaDePagamento | currency: 'BRL'}}</h5>
              </div>


              <div class="media mt-0" *ngIf="!_pedido.producaoInterna">
                <div class="media-body">
                  <h5 class="mt-0 mb-1"><span>Total Pago</span></h5>
                </div>
                <h5 class="mt-0 preco font-18"><strong>{{_pedido.total | currency: 'BRL'}}</strong></h5>
              </div>

              <div class="media mt-0" *ngIf="_pedido.totalResgatado">
                <div class="media-body">
                  <h5 class="mt-0 mb-1"><span>Total Resgatado</span></h5>
                </div>
                <h5 class="mt-0 resgate font-18"><strong>{{_pedido.totalResgatado  }} {{_pedido.acumulo}}</strong></h5>
              </div>

            </div>

            <div class="pamento "  *ngFor="let pagamento of _pedido.pagamentos; let primeiro = first;">

              <div class="media">
                <div class="media-body" *ngIf="primeiro && _pedido.pagamentos.length === 1">
                  <h5 class="mt-0 mb-1"><span>  Pagamento em:</span>
                  </h5>

                </div>
                <h5 class="mt-0  ">
                  {{pagamento.descricao.toUpperCase()  }}
                  <ng-container *ngIf="_pedido.pagamentos.length > 1">
                    <span   [hidden]="pagamento.resgate"> ({{pagamento.valor | currency: "BRL" }})</span>
                    <span   [hidden]="!pagamento.resgate"> (-{{pagamento.valor}} {{_pedido.acumulo}})</span>
                  </ng-container>

                  <span *ngIf="pagamento.online" class="badge badge-primary">Online</span>
                  <span *ngIf="pagamento.autenticado" class="badge badge-success ml-1">Autenticado</span>
                  <span *ngIf="_pedido.transacao?.codigo && pagamento.online" class="text-muted">
                    <br>cod transação: <b>{{_pedido.transacao.codigo}}</b></span>
                </h5>
              </div>

              <ng-container *ngIf="pagamento.levarTroco" >
                 <div class="media" >
                    <div class="media-body"  >
                      <h5 class="mt-0 mb-1"><span>  Troco para:</span>
                      </h5>

                    </div>
                     <h5 class="mt-0  ">
                        {{pagamento.trocoPara | currency: "BRL"}}
                      </h5>

                </div>
                 <div class="media" >
                  <div class="media-body"  >
                    <h5 class="mt-0 mb-1"><span> Valor do troco:</span>
                    </h5>
                  </div>
                  <h5 class="mt-0  ">
                    {{pagamento.valorTroco | currency: "BRL"}}
                  </h5>

                </div>
               </ng-container>

            </div>

            <div class="pamento" *ngIf="_pedido.fiado && (!_pedido.pagamentos || !_pedido.pagamentos.length)">
              <div class="media">
                <div class="media-body">
                  <h5 class="mt-0 mb-1"><span>Pagamento em:</span></h5>
                </div>
                <h5 class="mt-0">
                  <span class="badge badge-danger">Fiado</span>
                </h5>
              </div>
            </div>

            <div class="media" *ngIf=" _pedido.entregador">
              <div class="media-body">
                <h5 class="mt-0 mb-1"><span>Entregador</span>
                </h5>

              </div>

              <h5 class="mt-0">
                {{_pedido.entregador}}</h5>

            </div>

            <ng-container *ngIf="_pedido.pontosGanhos" >
              <div class="linha mt-0 mb-0"  ></div>
              <div class="media mt-2" >
                <div class="media-body"  >
                  <h5 class="mt-0 mb-1 text-muted">{{ _pedido.temCashback ? 'Cashback a confirmar' : ' Pontos a confirmar:' }}
                  </h5>

                </div>
                <h5 class="mt-0  ">
                  {{_pedido.pontosGanhosDescricao }}
                </h5>

              </div>
            </ng-container>

            <h5  *ngIf="_pedido.observacoes"><span class="text-muted">Observações:</span>  "{{_pedido.observacoes}}"</h5>

            <div style="height: 40px" class="mobile"></div>


          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-xl-4 col-sm-6"  [ngClass]="{'col-xl-6': modal}">

      <app-acao-pedido-disputa  *ngIf="_pedido.disputa " [pedido]="_pedido" [modoGrupoLojas]="modoGrupoLojas"></app-acao-pedido-disputa>

      <div class="card-box ribbon-box">

        <app-pedido-ribbon [pedido]="_pedido"></app-pedido-ribbon>

        <h4 class="header-title mb-3 mt-1">Acompanhamento do pedido

          <button   type="button"   class="k-button k-primary"  [hidden]="_pedido.multipedido" kendoButton
                    (click)="mudarStatusPedido(_pedido)" title="alterar status" kendoTooltip *ngIf="!_pedido.cancelado && _pedido.aceito">
            <i class="fa fa-edit"></i></button>

          <ng-container *ngIf="(!_pedido.cancelado && !_pedido.finalizado) ||
                                           (_pedido.disputa && !_pedido.disputa.resultadoDisputa)">
            <app-sincronizar-keeta-status [pedido]="_pedido" [modoGrupoLojas]="modoGrupoLojas" *ngIf="_pedido.doKeeta">  </app-sincronizar-keeta-status>

            <app-sincronizar-99food-status [pedido]="_pedido" [modoGrupoLojas]="modoGrupoLojas" *ngIf="_pedido.do99food  "> </app-sincronizar-99food-status>

            <button class="btn btn-warning btn-xs ml-1" *ngIf="_pedido.doOpenDelivery"
                    title="sincronizar com OpenDelivery" kendoTooltip
                    (click)="sincronizarPedidoOpenDelivery($event)">
              <i class="fa fa-lg fa-sync cpointer" *ngIf="!_pedido.sincronizando"></i>
              <i class="k-icon k-i-loading fa-lg" *ngIf="_pedido.sincronizando"></i>
            </button>

          </ng-container>




        </h4>

        <p class="text-success font11 mb-2" *ngIf="mensagemSincronizacaoOpenDelivery">
          {{mensagemSincronizacaoOpenDelivery}}
        </p>
        <p class="text-danger font11 mb-2" *ngIf="erroSincronizacaoOpenDelivery">
          {{erroSincronizacaoOpenDelivery}}
        </p>

        <div class="ribbon-content">
          <div class="track-order-list">

            <ul class="list-unstyled">
              <li *ngIf="!_pedido.aguardandoPagamentoOnline" [ngClass]=" {'completed': _pedido.statusOrdem > 0  ,
                              'actived': _pedido.statusOrdem ==  0   }">
                <span class="active-dot dot" *ngIf="_pedido.statusOrdem ==  0   "></span>
                <h5 class="mt-0 mb-1">Pedido Realizado</h5>
                <p class="text-muted">{{ _pedido.horarioDescricao }}
                  <span class="badge badge-light">{{_pedido.duracaoDescricao}}</span>
                </p>

                <h5 class="text-success" *ngIf="!_pedido.aceito && !_pedido.cancelado">
                  <b>Aguardando confirmação do pedido</b>
                </h5>
              </li>

              <ng-container *ngIf="!_pedido.aguardandoPagamentoOnline && !_pedido.cancelado && _pedido.aceito">
                <li [ngClass]=" {'completed':  _pedido.statusOrdem > 1 }">
                  <span class="active-dot dot" *ngIf="_pedido.statusOrdem ==  1">      </span>
                  <h5 class="mt-0 mb-1">Em preparação</h5>
                  <p class="text-muted"> &nbsp;
                    <span class="text-muted" *ngIf="_pedido.statusOrdem == 1">{{_pedido.horarioAtualizacaoDescricao}}</span>
                  </p>
                </li>

                <li [ngClass]=" {'completed': _pedido.statusOrdem > 2  }">
                  <h5 class="mt-0 mb-1">Pronto</h5>
                  <span class="active-dot dot" *ngIf="_pedido.statusOrdem == 2">                </span>
                  <p class="text-muted"> &nbsp;
                    <span class="text-muted" *ngIf="_pedido.statusOrdem ==  2">{{_pedido.horarioAtualizacaoDescricao}}</span>
                  </p>
                </li>
                <ng-container *ngIf="!_pedido.mesa">
                  <li [ngClass]="{'completed': _pedido.statusOrdem > 3  }">
                    <span class="active-dot dot" *ngIf="_pedido.statusOrdem===3"></span>
                    <h5 class="mt-0 mb-1"> Saiu para entrega</h5>
                    <p class="text-muted"> &nbsp;
                      <span   *ngIf="_pedido.statusOrdem === 3">{{_pedido.horarioAtualizacaoDescricao}}</span>
                    </p>

                  </li>

                  <li [ngClass]="{'completed': _pedido.statusOrdem == 4  }">

                    <h5 class="mt-0 mb-1">Entregue</h5>
                    <p class="text-muted"> &nbsp;
                      <span   *ngIf="_pedido.statusOrdem === 4">{{_pedido.horarioAtualizacaoDescricao}}</span>
                    </p>
                  </li>
                </ng-container>
              </ng-container>

              <li class="actived" *ngIf="_pedido.aguardandoPagamentoOnline">
                <span class="active-dot dot"  ></span>
                <h5 class="mt-0 mb-1 text0 "><b>
                  {{_pedido.aguardandoEstorno ? 'Reembolso solicitado' : 'Aguardando confirmação pagamento online'}}

                </b></h5>
                <p class="text-muted">{{ _pedido.horarioDescricao }}
                  <span class="badge badge-light">{{_pedido.duracaoDescricao}}</span>
                </p>

                <app-sincronizar-pagamento-online [pedido]="_pedido" [modoGrupoLojas]="modoGrupoLojas" >

                </app-sincronizar-pagamento-online>
              </li>

              <li class="completed"  *ngIf="_pedido.cancelado">

                <h5 class="mt-0 mb-1">{{_pedido.status}}</h5>
                <p class="text-muted">
                  <span class="text-muted"  >{{_pedido.horarioAtualizacaoDescricao}}</span>
                </p>
              </li>


            </ul>

          </div>
          <div *ngIf="_pedido.motivoReprovacao" class="alert alert-danger alert-dismissible fade show mt-1" role="alert">
            Pagamento não aprovado: {{_pedido.motivoReprovacao}}
            <button type="button" class="close" data-dismiss="alert" aria-label="Fechar">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div *ngIf="erroAceitar" class="alert alert-danger alert-dismissible fade show mb-2 mt-2" role="alert">
            {{erroAceitar}}
            <button type="button" class="close" data-dismiss="alert" aria-label="Fechar">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>


      <div class="card-box ribbon-box nota-fiscal-pedido mt-2" *ngIf="!modal && obtenhaNfcePedido() as nfce">
        <div class="ribbon ribbon-info float-right">
          <span>NFC-e</span>
        </div>

        <h4 class="header-title mb-3 mt-1">Nota fiscal</h4>

        <div class="ribbon-content">
          <div *ngIf="mensagemSucessoNotaFiscal" class="alert alert-success alert-dismissible fade show" role="alert">
            {{mensagemSucessoNotaFiscal}}
            <button type="button" class="close" aria-label="Fechar" (click)="mensagemSucessoNotaFiscal = ''">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div *ngIf="mensagemErroNotaFiscal" class="alert alert-danger alert-dismissible fade show" role="alert">
            {{mensagemErroNotaFiscal}}
            <button type="button" class="close" aria-label="Fechar" (click)="mensagemErroNotaFiscal = ''">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="nota-fiscal-resumo">
            <div class="nota-fiscal-linha">
              <span class="text-muted">Status</span>
              <span class="badge badge-pill" [ngClass]="obtenhaClasseStatusNfce(nfce.status)">
                {{obtenhaStatusNfce(nfce.status)}}
              </span>
            </div>

            <div class="nota-fiscal-linha">
              <span class="text-muted">Numero</span>
              <strong>{{nfce.numeroNFe || '-'}}</strong>
            </div>

            <div class="nota-fiscal-linha">
              <span class="text-muted">Serie</span>
              <strong>{{nfce.serie || '-'}}</strong>
            </div>

            <div class="nota-fiscal-linha">
              <span class="text-muted">Emissao</span>
              <strong>{{nfce.dataDeEmissao | date:'dd/MM/yyyy HH:mm'}}</strong>
            </div>

            <div class="nota-fiscal-linha">
              <span class="text-muted">Valor</span>
              <strong class="preco">{{nfce.valorTotalNFe | currency:'BRL'}}</strong>
            </div>
          </div>

          <div class="mt-2" *ngIf="nfce.chaveDeAcesso">
            <span class="text-muted d-block mb-1">Chave de acesso</span>
            <span class="text-monospace small nota-fiscal-chave">{{formatChaveAcesso(nfce.chaveDeAcesso)}}</span>
          </div>

          <div class="alert alert-warning mt-3 mb-0" *ngIf="nfce.motivo">
            {{nfce.motivo}}
          </div>

          <div class="btn-group d-flex mt-3" role="group">
            <button type="button"
                    class="btn btn-outline-primary btn-sm w-100"
                    (click)="baixarXmlNfcePedido()"
                    [disabled]="baixandoXmlNotaFiscal">
              <i class="k-i-loading k-icon mr-1" *ngIf="baixandoXmlNotaFiscal"></i>
              <i class="fas fa-file-code mr-1" *ngIf="!baixandoXmlNotaFiscal"></i>
              XML
            </button>

            <button type="button"
                    class="btn btn-outline-success btn-sm w-100"
                    (click)="imprimirNfcePedido()"
                    [disabled]="imprimindoNotaFiscal">
              <i class="k-i-loading k-icon mr-1" *ngIf="imprimindoNotaFiscal"></i>
              <i class="fas fa-print mr-1" *ngIf="!imprimindoNotaFiscal"></i>
              Imprimir
            </button>
          </div>

          <button type="button" class="btn btn-link btn-sm px-0 mt-2" (click)="abrirDanfeNfcePedido()">
            Abrir DANFE
          </button>
        </div>
      </div>


      <div *ngIf="!_pedido.aceito && !_pedido.cancelado" class="mb-3 mt-2"  class="alert alert-info">
        <p *ngIf="_pedido.doOpenDelivery && _pedido.aguardandoPdv" role="status">
          <strong>Cancelamento solicitado — aguardando confirmação da plataforma.</strong>
          O pedido só será cancelado após a confirmação.
        </p>
        <p class="text-danger" *ngIf="_pedido.doOpenDelivery && _pedido.motivoRejeicao" role="alert">
          A plataforma recusou o cancelamento: {{_pedido.motivoRejeicao}}
        </p>
        <div [hidden]="_pedido.confirmarRejeitar">
          <h5>Você recebeu um novo Pedido</h5>
          <div class="btn-group " >
            <button   type="button"   class="btn  btn-success " [disabled]="processando"
                      (click)="aceitarPedido()" title="aceitar pedido" kendoTooltip >
              <i class="fa fa-check" *ngIf="!processando"></i>
              <i class="k-i-loading k-icon " *ngIf="processando"></i>
              Aceitar Pedido</button>


            <button type="button" class="btn  btn-danger ml-2"
                    title="cancelar pedido" kendoTooltip (click)="_pedido.confirmarRejeitar = true">

              <i class="fa fa-times-circle"  ></i>
              Rejeitar Pedido
            </button>
          </div>
        </div>
        <ng-container *ngIf="_pedido.confirmarRejeitar">
          <h5>Confirma que não quer aceitar esse pedido?  </h5>
          <div class="btn-group"  >
            <button class="btn btn-danger   " (click)="rejeitarPedido()" [disabled]="processando">
              <i class="k-i-loading k-icon " *ngIf="processando"></i> Rejeitar Pedido
            </button>
            <button class="btn  btn-secondary   ml-1" (click)="_pedido.confirmarRejeitar = false" [disabled]="processando">
              Voltar
            </button>
          </div>
        </ng-container>
      </div>
  </div>

</div>

<app-modal-comissionamento-pedido *ngIf="pedidoComissionamento"
                                  [pedido]="pedidoComissionamento"
                                  [labelOperacional]="labelOperacionalComissionado()"
                                  (fechou)="fecheModalComissionamento()"
                                  (itemSalvo)="atualizeComissionadoNoPedido($event); carregueHistoricoPedido()">
</app-modal-comissionamento-pedido>

<kendo-dialog *ngIf="itemConfiguracaoComissao"
              class="configuracao-comissao-dialog"
              (close)="fecheModalConfiguracaoComissao()"
              [minWidth]="320"
              [width]="900">
  <kendo-dialog-titlebar>
    Configurar comissão do produto
  </kendo-dialog-titlebar>

  <div class="configuracao-comissao-modal">
    <section class="configuracao-comissao-produto">
      <div class="configuracao-comissao-produto-icone">
        <i class="fas fa-box-open"></i>
      </div>

      <div class="configuracao-comissao-produto-conteudo">
        <span class="configuracao-comissao-tipo">
          <i class="fas fa-tag mr-1"></i>
          Produto
        </span>
        <h3>{{itemConfiguracaoComissao.produto?.nome || itemConfiguracaoComissao.descricao}}</h3>

        <div class="configuracao-comissao-produto-removido" *ngIf="itemConfiguracaoComissao.produto?.removido">
          <i class="fas fa-exclamation-triangle mr-1"></i>
          Este produto está removido.
        </div>

        <div class="configuracao-comissao-dados">
          <div class="configuracao-comissao-dado">
            <span class="configuracao-comissao-dado-icone"><i class="fas fa-hashtag"></i></span>
            <span class="configuracao-comissao-dado-texto">
              <small>ID</small>
              <strong>{{itemConfiguracaoComissao.produto?.id}}</strong>
            </span>
          </div>
          <div class="configuracao-comissao-dado" *ngIf="itemConfiguracaoComissao.produto?.codigoPdv">
            <span class="configuracao-comissao-dado-icone"><i class="fas fa-barcode"></i></span>
            <span class="configuracao-comissao-dado-texto">
              <small>Código PDV</small>
              <strong>{{itemConfiguracaoComissao.produto.codigoPdv}}</strong>
            </span>
          </div>
          <div class="configuracao-comissao-dado">
            <span class="configuracao-comissao-dado-icone"><i class="fas fa-tag"></i></span>
            <span class="configuracao-comissao-dado-texto">
              <small>Categoria</small>
              <strong>{{itemConfiguracaoComissao.produto?.categoria?.nome || 'Sem categoria'}}</strong>
            </span>
          </div>
          <div class="configuracao-comissao-dado">
            <span class="configuracao-comissao-dado-icone"><i class="fas fa-dollar-sign"></i></span>
            <span class="configuracao-comissao-dado-texto">
              <small>Valor</small>
              <strong>{{itemConfiguracaoComissao.valor | currency:'BRL'}}</strong>
            </span>
          </div>
        </div>
      </div>
    </section>

    <div class="alert alert-danger mt-3 mb-0" *ngIf="erroConfiguracaoComissao">
      {{erroConfiguracaoComissao}}
    </div>

    <div class="text-center p-4" *ngIf="carregandoComissoesConfiguracao">
      <i class="k-i k-i-loading"></i>
    </div>

    <ng-container *ngIf="!carregandoComissoesConfiguracao">
      <div class="alert alert-info mt-3 mb-0" *ngIf="!comissoesConfiguracao.length && !erroConfiguracaoComissao">
        Nenhuma comissão ativa cadastrada. Cadastre uma comissão no módulo de Comissionamento para continuar.
      </div>

      <div class="form-group configuracao-comissao-campo mt-4 mb-0" *ngIf="comissoesConfiguracao.length">
        <label for="comissaoProdutoPedido">Comissão vinculada</label>
        <select id="comissaoProdutoPedido"
                class="form-control configuracao-comissao-select"
                [(ngModel)]="comissaoConfiguracaoId"
                [disabled]="salvandoComissaoProduto">
          <option [ngValue]="null">Selecione uma comissão</option>
          <option *ngFor="let comissao of comissoesConfiguracao" [ngValue]="comissao.id">
            {{comissao.nome}} - {{comissao.valorFixo | currency:'BRL'}}
          </option>
        </select>
        <small class="form-text text-muted">
          A comissão será configurada no produto, inclusive se ele tiver sido removido do catálogo.
        </small>
      </div>
    </ng-container>
  </div>

  <kendo-dialog-actions class="configuracao-comissao-acoes">
    <button kendoButton
            type="button"
            class="configuracao-comissao-cancelar"
            (click)="fecheModalConfiguracaoComissao()"
            [disabled]="salvandoComissaoProduto">
      Cancelar
    </button>
    <button kendoButton
            type="button"
            class="configuracao-comissao-salvar"
            [primary]="true"
            (click)="salveConfiguracaoComissaoProduto()"
            [disabled]="carregandoComissoesConfiguracao || salvandoComissaoProduto || !comissaoConfiguracaoId">
      <i class="k-i k-i-loading mr-1" *ngIf="salvandoComissaoProduto"></i>
      Salvar
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<div class="row" *ngIf="moduloPagamentosEletronicosAtivo && _pedido?.id">
  <div class="col-12 col-xl-9 col-sm-12">
    <div class="card-box connecttef-pedido-card">
      <div class="connecttef-pedido-header">
        <div class="connecttef-pedido-title">
          <span><i class="fas fa-credit-card"></i></span>
          <div><small>ConnectTEF</small><h4 class="header-title mb-0">Pagamento integrado</h4></div>
        </div>
        <button type="button" class="btn btn-sm btn-outline-primary connecttef-acompanhar"
                *ngIf="podeCobrarPagamentoIntegrado"
                (click)="abraPagamentoEletronico()">
          <i class="fas fa-credit-card mr-1"></i> Cobrar na máquina integrada
        </button>
      </div>
      <div class="connecttef-loading" *ngIf="carregandoTransacoesConnectTef"><i class="fas fa-spinner fa-spin mr-2"></i>Carregando transações...</div>
      <div class="connecttef-empty" *ngIf="!carregandoTransacoesConnectTef && !transacoesConnectTef.length">
        <i class="fas fa-info-circle"></i><span>Nenhuma cobrança integrada foi iniciada para este pedido.</span>
      </div>
      <div class="table-responsive connecttef-table-wrapper" *ngIf="transacoesConnectTef.length">
        <table class="table mb-0 connecttef-table">
          <thead>
          <tr><th>Referência</th><th>Operação</th><th>Valor</th><th>Terminal</th><th>Pagamento</th><th>Fiscal</th><th></th></tr>
          </thead>
          <tbody>
          <tr *ngFor="let transacao of transacoesConnectTef">
            <td><span class="connecttef-reference" [title]="transacao.identificacao">{{transacao.identificacao}}</span></td>
            <td><span class="connecttef-operation"><i class="fas" [ngClass]="transacao.operacao === 'REVERSAL' ? 'fa-undo-alt' : 'fa-credit-card'"></i>{{transacao.operacao === 'REVERSAL' ? 'Estorno' : 'Pagamento'}}</span></td>
            <td><strong>{{transacao.valor | currency:'BRL'}}</strong></td>
            <td>{{transacao.terminal?.numeroSerieTerminal || transacao.terminal?.numeroSerieAutomacao || ('#' + transacao.terminal?.id)}}</td>
            <td><span class="connecttef-status" [ngClass]="classeStatusConnectTef(transacao.status)">{{textoStatusConnectTef(transacao.status)}}</span></td>
            <td><span class="connecttef-fiscal">{{textoStatusFiscalConnectTef(transacao.statusFiscal)}}</span></td>
            <td class="text-right">
              <button type="button" class="btn btn-sm btn-outline-danger"
                      *ngIf="podeEstornarConnectTef(transacao)"
                      (click)="abraEstornoConnectTef(transacao)">
                <i class="fas fa-undo-alt mr-1"></i> Estornar
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<app-pagamento-eletronico-dialog
  [aberto]="pagamentoEletronicoAberto"
  [pedido]="_pedido"
  [pagamentos]="_pedido?.pagamentos || []"
  (finalizado)="concluaPagamentoEletronicoPedido()"
  (fechado)="fechePagamentoEletronicoPedido()">
</app-pagamento-eletronico-dialog>

<kendo-dialog *ngIf="estornoConnectTefAberto" title="Estornar pagamento eletrônico"
              (close)="fecheEstornoConnectTef()" [minWidth]="320" [width]="520">
  <div class="connecttef-refund-dialog">
    <div class="connecttef-refund-summary">
      <span><i class="fas fa-undo-alt"></i></span>
      <div><small>Valor integral do estorno</small><strong>{{transacaoParaEstornoConnectTef?.valor | currency:'BRL'}}</strong></div>
    </div>
    <p>O pedido será enviado ao mesmo terminal usado no pagamento. A conclusão será atualizada automaticamente.</p>
    <div class="alert alert-danger" *ngIf="erroEstornoConnectTef">{{erroEstornoConnectTef}}</div>
    <div class="form-group mb-0">
      <label for="justificativaEstornoConnectTef">Motivo do estorno</label>
      <textarea id="justificativaEstornoConnectTef" class="form-control" rows="3" maxlength="500"
                placeholder="Explique por que este pagamento será estornado"
                [(ngModel)]="justificativaEstornoConnectTef"
                [disabled]="solicitandoEstornoConnectTef"></textarea>
      <small class="form-text text-muted">A justificativa ficará registrada no histórico da operação.</small>
    </div>
  </div>
  <kendo-dialog-actions>
    <button type="button" class="btn btn-light" (click)="fecheEstornoConnectTef()"
            [disabled]="solicitandoEstornoConnectTef">Cancelar</button>
    <button type="button" class="btn btn-danger" (click)="confirmeEstornoConnectTef()"
            [disabled]="solicitandoEstornoConnectTef || !justificativaEstornoConnectTef?.trim()">
      <i class="fas fa-spinner fa-spin mr-1" *ngIf="solicitandoEstornoConnectTef"></i>
      Solicitar estorno
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<div class="row" [hidden]="modal">
   <div class="col-12 col-xl-9 col-sm-12">
     <div class="card-box ribbon-box">
       <div class=" ribbon ribbon-dark float-right">
         <span>Historico</span>
       </div>

       <h4 class="header-title mb-3 mt-1">
         Historico do pedido
       </h4>

       <div class="ribbon-content">
         <kendo-grid [data]="historico"
                     [loading]="carregandoHistorico" style="min-height: 150px;">
           <kendo-grid-messages
             pagerPage="Página"
             pagerOf="de"
             pagerItems="itens"
             noRecords="Sem historico"
             loading="Carregando"
             pagerItemsPerPage="ítems por página"
           >
           </kendo-grid-messages>
           <kendo-grid-column title="Alteração"   >
             <ng-template kendoGridCellTemplate let-dataItem  >
               <span class="text-blue"><b>{{dataItem.descricao}}</b></span>
             </ng-template>
           </kendo-grid-column>

           <kendo-grid-column title="Horário"  [width]="180"  >
             <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
               <span class="text-muted"><b>{{dataItem.horario | date: 'dd/MM/YYYY HH:mm:ss'}}</b></span>
             </ng-template>
           </kendo-grid-column>

           <kendo-grid-column title="Operador" [width]="180" >
             <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
               <span>
                 <b>{{dataItem.operador ? dataItem.operador.nome : (dataItem.clienteApi ? dataItem.clienteApi.nome : '-')}}</b>
               </span>
             </ng-template>
           </kendo-grid-column>

           <kendo-grid-column title="Api"   [width]="100">
             <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
               <span class="badge badge-success" *ngIf="dataItem.clienteApi || dataItem.origem">Sim</span>
               <span class="badge badge-danger" *ngIf="!dataItem.clienteApi && !dataItem.origem">Não

          </span>
             </ng-template>
           </kendo-grid-column>

         </kendo-grid>
       </div>
   </div>
  </div>
</div>
